import gql from 'graphql-tag'

export const GET_IMAGES = gql`
  query Query {
    getAllLoginImages
  }
`
